import React from "react";
import LoginComponent from "../../component/login/index";
export function Login() {
  return (
    <div  >
      <LoginComponent />
    </div>
  );
}
